<template>
  <div>
    <highcharts class="chart" :options="chartOptions" ref="chart" :style="styleObject"></highcharts>
    <div>
    <p>Click and drag to zoom in to different parts of the graph.</p>
  </div>
  </div>
</template>

<script>
import { waterQualityThresholds } from '../../lib/constants'
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting';
Highcharts.setOptions({lang: {thousandsSep:','}})
import NoDataToDisplay from 'highcharts/modules/no-data-to-display'
NoDataToDisplay(Highcharts);
Exporting(Highcharts);

export default {
  props: ['gwidth', 'gheight'],

  data() {

    return {
      test: 'test',
      waterQualityThresholds: waterQualityThresholds,
      
      chartOptions: {
        chart: {
          type: 'scatter',
          zoomType: 'x'
        },

        lang: {
          noData: 'No observed data to display in this area.<br> Select a different area to see data.'
        },
        tooltip: {
          pointFormat: "{point.x:%Y-%m-%d %H:%M} <br> {point.y}"     
        },

        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%b<br/>%Y}'
          },
          startOnTick: true,
          endOnTick: true
        },
        yAxis: {
          type: 'linear',
          title: {
            text: 'parameter (units)'
          },
          plotLines: [{
            color: '#ff8737',
            width: 3,
            dashStyle: 'LongDash',
            opacity: 0.5,
            value: -10,
            zIndex: 1,
            label: {
              text: 'threshold',
              align: 'right',
              x: 0,
              y: -10
            }
          },
          {
            color: '#ff8737',
            width: 3,
            dashStyle: 'LongDash',
            opacity: 0.5,
            value: -10,
            zIndex: 1,
            label: {
              text: 'threshold 2',
              align: 'right',
              x: 0,
              y: -10
            }
          }]
        },
        legend: {
          enabled: true
        },
        series: [
          {
            name: 'Measurement',
            data: this.data,
            showInLegend: false
          },
        ]
      },
      startYear: null,
      endYear: null,
      minYear: null,
      maxYear: null,
    }
  },
  computed: {
    styleObject() {
      return {
        width: this.gwidth,
        height: this.gheight
      }
    },
    station() {
      return this.$store.state.station;
    },
    waterQualityGraphVariable() {
      return this.$store.state.waterQualityGraphVariable;
    },
    waterQualityGraphVariableCapital() {
      const titles = this.$store.state.waterQualityGraphVariable.split(" ");
      let capitalTitle = titles.map((word) => {
        return word[0].toUpperCase() + word.substring(1);
      }).join(" ");
      if ((capitalTitle == 'Nitrogen') || (capitalTitle == 'Phosphorus')) {
        capitalTitle = 'Total ' + capitalTitle;
      }
      return capitalTitle;
    },
    stationEmbaymentCapital() {
      let nameStringArray = this.$store.state.stationEmbayment.split(" ");
      nameStringArray.forEach((word, index) => {
        if (word[0] == '(') {
          nameStringArray[index] = word.substring(0, 2) + word.slice(2).toLowerCase();
        } else {
          nameStringArray[index] = word[0] + word.slice(1).toLowerCase();
        }
      });
      return nameStringArray.join(' ');    
    },
    showLargeGraph() {
      return this.$store.state.showLargeGraph;
    },
    plotWaterQualityGraph() {
      return this.$store.state.plotWaterQualityGraph;
    }
  },
  watch: {
    '$store.state.station'() {
      this.plotData();
    },
    data: {
      handler(newData) {
        this.updateYears(newData);
      }, deep: true
    }
  },
  methods: {

    parameterMapper(parameterName) {
      const waterQualityMap = new Map();
      waterQualityMap.set('chlorophyl-a', 'CHLA');
      waterQualityMap.set('dissolved oxygen', 'DO');
      waterQualityMap.set('e. coli', 'ECOLI');
      waterQualityMap.set('enterococcus','ENT');
      waterQualityMap.set('pH', 'PH');
      waterQualityMap.set('salinity', 'SAL');
      waterQualityMap.set('temperature', 'TEMP');
      waterQualityMap.set('nitrogen', 'TN');
      waterQualityMap.set('phosphorus', 'TP');
      waterQualityMap.set('turbidity', 'TURB'); 
      return waterQualityMap.get(parameterName); 
    },
    plotData() {
      if (this.plotWaterQualityGraph == true) {
        const chart = this.$refs.chart.chart;
        chart.setTitle({ text: this.station + ' <br>' + this.stationEmbaymentCapital + " || " + this.waterQualityGraphVariableCapital});
        
       let parameterCode = this.parameterMapper(this.waterQualityGraphVariable);
        // fetch water quality data
        fetch('./data/wq/' + this.station +'.json')
        .then(response => {
          return response.json()
        }).then(json => {

          let activeData = json.filter(row => row.param == parameterCode)[0];

          // console.log(activeData)
          this.chartOptions.yAxis.title.text = this.waterQualityThresholds[this.waterQualityGraphVariable].title + ' (' + this.waterQualityThresholds[this.waterQualityGraphVariable].units + ')';    
          this.chartOptions.yAxis.type = this.waterQualityThresholds[this.waterQualityGraphVariable].scale;
          
          let dataSeries = [];

          activeData.values.forEach( row => {
              dataSeries.push({x: new Date(row.datetime).getTime(), y: row.value})

          })
          this.chartOptions.yAxis.min = this.waterQualityThresholds[this.waterQualityGraphVariable].minValue;
          let thresholdValue = Math.max(...this.waterQualityThresholds[this.waterQualityGraphVariable].value);
          let thresholdValueBuffer = thresholdValue * 1.05
          let maxDataValue = Math.max(...dataSeries.map(row => row.y))
          if ( maxDataValue > thresholdValue) {
            this.chartOptions.yAxis.max = maxDataValue;
          } else {
            this.chartOptions.yAxis.max = thresholdValueBuffer;
          }
          if (this.waterQualityGraphVariable == 'salinity') {
            this.chartOptions.yAxis.max = 35;
          }
          this.chartOptions.series[0].data = dataSeries;
          this.chartOptions.tooltip.pointFormat = "{point.x:%Y-%m-%d %H:%M} <br> {point.y} " + this.waterQualityThresholds[this.waterQualityGraphVariable].units
          this.chartOptions.yAxis.plotLines[0].value = this.waterQualityThresholds[this.waterQualityGraphVariable].value[0]
           if (this.waterQualityGraphVariable == 'salinity') {
            this.chartOptions.yAxis.plotLines[1].value = this.waterQualityThresholds[this.waterQualityGraphVariable].value[1];
            this.chartOptions.yAxis.plotLines[0].label.text = 'Estuarine: >' + this.waterQualityThresholds[this.waterQualityGraphVariable].value[0] + ' ' + this.waterQualityThresholds[this.waterQualityGraphVariable].units + '<br>' + this.waterQualityThresholds[this.waterQualityGraphVariable].type[0] + ': <' + this.waterQualityThresholds[this.waterQualityGraphVariable].value[0] + ' ' + this.waterQualityThresholds[this.waterQualityGraphVariable].units;
            this.chartOptions.yAxis.plotLines[1].label.text = 'Marine: >' + this.waterQualityThresholds[this.waterQualityGraphVariable].value[1] + ' ' + this.waterQualityThresholds[this.waterQualityGraphVariable].units;
            this.chartOptions.yAxis.plotLines[0].label.y = -20;
            console.log(this.chartOptions.yAxis.plotlines[0].label.y);
          } else if (this.waterQualityGraphVariable == 'pH') {
            this.chartOptions.yAxis.plotLines[1].value = this.waterQualityThresholds[this.waterQualityGraphVariable].value[1];
            this.chartOptions.yAxis.plotLines[0].label.text = this.waterQualityThresholds[this.waterQualityGraphVariable].type[0] +' Threshold: ' +
            this.waterQualityThresholds[this.waterQualityGraphVariable].value[0] + ' ' + this.waterQualityThresholds[this.waterQualityGraphVariable].units;
            this.chartOptions.yAxis.plotLines[1].label.text = this.waterQualityThresholds[this.waterQualityGraphVariable].type[1] +' Threshold: ' + this.waterQualityThresholds[this.waterQualityGraphVariable].value[1] + 
            ' ' + this.waterQualityThresholds[this.waterQualityGraphVariable].units + ''
            this.chartOptions.yAxis.plotLines[0].label.y = 15; 
          } else {
            this.chartOptions.yAxis.plotLines[1].value = -10;            
            this.chartOptions.yAxis.plotLines[0].label.text = this.waterQualityThresholds[this.waterQualityGraphVariable].type[0] + ' Threshold: ' + thresholdValue + ' ' + this.waterQualityThresholds[this.waterQualityGraphVariable].units + '';

            this.chartOptions.yAxis.plotLines[0].label.y = -10;            
          }         
          
        });
      } else {
        this.chartOptions.yAxis.title.text = 'parameter (units)';
        this.chartOptions.series[0].data = []
        this.chartOptions.yAxis.plotLines[0].value = -10;
        this.chartOptions.yAxis.plotLines[1].value = -10;
        this.chartOptions.series[1].name = 'Threshold';
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.plotData();
    })
  }
}
</script>

<style>
/* .highcharts-container {
    position: inherit !important;
}
.highcharts-tooltip {
    z-index: 9998;
    background-color:white;
    border:1px solid green;
    opacity:1;
}

.highcharts-tooltip div {
    background-color:white;
    border:1px solid green;
    opacity:1;
    z-index:9999!important;
} */

</style>
